export default __webpack_public_path__ + "static/media/teamMember3.aef6c6c0.png";